import { z } from 'zod';

export const PROJECT_STATUSES = {
  UNKNOWN: 'UNKNOWN',
  PARSING_DATA: 'PARSING_DATA',
  UPLOADING_TO_DB: 'UPLOADING_TO_DB',
  DONE: 'DONE',
  FAIL: 'FAIL',
  REMOVING: 'REMOVING',
  ARCHIVED: 'ARCHIVED',
} as const;

export const projectStatus = z.enum([
  PROJECT_STATUSES.UNKNOWN,
  PROJECT_STATUSES.PARSING_DATA,
  PROJECT_STATUSES.UPLOADING_TO_DB,
  PROJECT_STATUSES.DONE,
  PROJECT_STATUSES.FAIL,
  PROJECT_STATUSES.REMOVING,
  PROJECT_STATUSES.ARCHIVED,
]);

export type ProjectStatus = z.infer<typeof projectStatus>;

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  UNKNOWN: 'Uninitialized',
  PARSING_DATA: 'Parsing data',
  UPLOADING_TO_DB: 'Uploading to db',
  DONE: 'Ok',
  FAIL: 'Failure',
  REMOVING: 'Project removing',
  ARCHIVED: 'Archived',
};
